import * as React from 'react';
import { NotificationContentBreadcrumbs } from 'src/components/Inbox/NotificationContentBreadcrumbs';

export const InvoiceNotificationDetailsBreadcrumbs: React.FC<{
  invoiceNumber: string;
}> = ({ invoiceNumber }) => {
  const items = [
    { label: 'Invoices', path: '/invoices' },
    { label: invoiceNumber },
  ];

  return <NotificationContentBreadcrumbs items={items} />;
};
